import React from "react";
import { Card, CardBody } from "reactstrap";
import { FacebookForm } from "../../../../cores/facebookForm/interfaces/api/get-facebook-form";
import { useIntl } from "react-intl";


interface Props {
  onView: () => void;
  facebookForm: FacebookForm;
}

export default function FormCard(props: Props) {
  const intl = useIntl();
  const { facebookForm, onView } = props;
  const leadsCount = Number(facebookForm.leadsCount || 0);

  return (
    <Card key={facebookForm.id} className="facebook-form-card border-0">
      <CardBody className="facebook-form-card__body">
        <div className="facebook-form-card__top">
          <p className="facebook-form-card__title mb-1">{facebookForm.name}</p>
          <p className="facebook-form-card__id mb-0">ID: {facebookForm.id}</p>
        </div>

        <div className="facebook-form-card__bottom">
          <div className="facebook-form-card__leads">
            <span className="facebook-form-card__leads-label">
              {intl.formatMessage({ id: "app.facebookForm.leads" })}
            </span>
            <span className="facebook-form-card__leads-value">{leadsCount}</span>
          </div>
          <button type="button" className="facebook-form-card__view" onClick={onView}>
            {intl.formatMessage({ id: "app.facebookForm.seeLeads" })}
          </button>
        </div>
      </CardBody>
    </Card>
  );
}
